<template>
    <el-card>
        <template #header>
            <content-header />
        </template>

        <div class="header-button">
            <search-form ref="searchForm" :fields="search" />
            <div class="selections">
                <button-link type="success" to="/admin-roles/create">
                    <slot>添加角色</slot>
                </button-link>
            </div>
        </div>

        <el-table :data="roles" resource="admin-roles">
            <!--<el-table-column prop="id" label="ID" width="60"/>-->
            <el-table-column prop="name" label="名称" width="150" />
            <el-table-column prop="slug" label="标识" width="150" />
            <el-table-column label="权限" min-width="400">
                <template #default="{ row }">
                    <el-tag
                        v-for="i of row.permissions"
                        :key="i.id"
                        class="mr-1"
                    >
                        {{ i.name }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="添加时间" width="180" />
            <el-table-column prop="updated_at" label="修改时间" width="180" />
            <el-table-column label="操作" width="150">
                <template #default="{ row, $index }">
                    <el-button-group>
                        <row-to-edit />
                        <row-destroy />
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="card-footer">
            <pagination :page="page" />
        </div>
    </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import { getAdminRoles } from "@/api/admin-roles";
import Pagination from "@c/Pagination";
import RowDestroy from "@c/LzTable/RowDestroy";
import RowToEdit from "@c/LzTable/RowToEdit";
import ButtonLink from "@c/ButtonLink";
import { mixinsAutoPageSize } from "@/libs/utils";

export default {
    name: "Index",
    components: {
        RowToEdit,
        RowDestroy,
        SearchForm,
        Pagination,
        ButtonLink,
    },
    data() {
        return {
            search: [
                {
                    field: "id",
                    label: "ID",
                },
                {
                    field: "name",
                    label: "名称",
                },
                {
                    field: "slug",
                    label: "标识",
                },
                {
                    field: "permission_name",
                    label: "权限",
                },
            ],
            roles: [],
            page: null,
            first_blood: true,
        };
    },
    mixins: [mixinsAutoPageSize],
    watch: {
        $route: {
            async handler(newVal) {
                await this.autoPageSize(53, newVal);
                const {
                    data: { data, meta },
                } = await getAdminRoles(newVal.query);
                this.roles = data;
                console.log(data, "表格数据");
                this.page = meta;
            },
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.header-button {
    display: flex;
    justify-content: space-between;
    .selections {
        display: inline-block;
        margin-right: 10px;
    }
}
</style>
